module.exports = __webpack_public_path__ + "img/katarina_living_room_3.80d5edf1.jpg";